import React, { useState } from "react";
import { Box, Dialog, Tab, Tabs } from "@mui/material";

function MultiTabDialog({ open, onClose, dialogTabs }) {
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <Box sx={{ width: "100%" }}>
        {dialogTabs && dialogTabs.length > 1 && (
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            aria-label="tabs"
            sx={{ borderBottom: 1, borderColor: "divider" }}
          >
            {dialogTabs.map((dialogTabs, index) => (
              <Tab key={index} label={dialogTabs.label} />
            ))}
          </Tabs>
        )}
        {dialogTabs &&
          dialogTabs.map((dialogTabs, index) => (
            <Box key={index} role="tabpanel" hidden={tabIndex !== index} p={3}>
              {tabIndex === index && dialogTabs.component}
            </Box>
          ))}
      </Box>
    </Dialog>
  );
}

export default MultiTabDialog;
